import { defineComponent as S, ref as f, computed as x, onDeactivated as L, h as p, mergeProps as j } from "vue";
import { useMergedClsPrefix as D } from "./ghl-ui.es854.js";
import $ from "./ghl-ui.es1005.js";
import k from "./ghl-ui.es855.js";
import E from "./ghl-ui.es1006.js";
import P from "./ghl-ui.es374.js";
function b(i) {
  return `${i}-ellipsis--line-clamp`;
}
function R(i, s) {
  return `${i}-ellipsis--cursor-${s}`;
}
const B = Object.assign(Object.assign({}, k.props), {
  expandTrigger: String,
  lineClamp: [Number, String],
  tooltip: {
    type: [Boolean, Object],
    default: !0
  }
}), q = S({
  name: "Ellipsis",
  inheritAttrs: !1,
  props: B,
  setup(i, {
    slots: s,
    attrs: o
  }) {
    const n = D(), a = k("Ellipsis", "-ellipsis", $, E, i, n), m = f(null), g = f(null), u = f(null), c = f(!1), v = x(() => {
      const {
        lineClamp: e
      } = i, {
        value: l
      } = c;
      return e !== void 0 ? {
        textOverflow: "",
        "-webkit-line-clamp": l ? "" : e
      } : {
        textOverflow: l ? "" : "ellipsis",
        "-webkit-line-clamp": ""
      };
    });
    function C() {
      let e = !1;
      const {
        value: l
      } = c;
      if (l)
        return !0;
      const {
        value: t
      } = m;
      if (t) {
        const {
          lineClamp: r
        } = i;
        if (O(t), r !== void 0)
          e = t.scrollHeight <= t.offsetHeight;
        else {
          const {
            value: T
          } = g;
          T && (e = T.getBoundingClientRect().width <= t.getBoundingClientRect().width);
        }
        w(t, e);
      }
      return e;
    }
    const h = x(() => i.expandTrigger === "click" ? () => {
      var e;
      const {
        value: l
      } = c;
      l && ((e = u.value) === null || e === void 0 || e.setShow(!1)), c.value = !l;
    } : void 0);
    L(() => {
      var e;
      i.tooltip && ((e = u.value) === null || e === void 0 || e.setShow(!1));
    });
    const y = () => p("span", Object.assign({}, j(o, {
      class: [`${n.value}-ellipsis`, i.lineClamp !== void 0 ? b(n.value) : void 0, i.expandTrigger === "click" ? R(n.value, "pointer") : void 0],
      style: v.value
    }), {
      ref: "triggerRef",
      onClick: h.value,
      onMouseenter: (
        // get tooltip disabled will derive cursor style
        i.expandTrigger === "click" ? C : void 0
      )
    }), i.lineClamp ? s : p("span", {
      ref: "triggerInnerRef"
    }, s));
    function O(e) {
      if (!e)
        return;
      const l = v.value, t = b(n.value);
      i.lineClamp !== void 0 ? d(e, t, "add") : d(e, t, "remove");
      for (const r in l)
        e.style[r] !== l[r] && (e.style[r] = l[r]);
    }
    function w(e, l) {
      const t = R(n.value, "pointer");
      i.expandTrigger === "click" && !l ? d(e, t, "add") : d(e, t, "remove");
    }
    function d(e, l, t) {
      t === "add" ? e.classList.contains(l) || e.classList.add(l) : e.classList.contains(l) && e.classList.remove(l);
    }
    return {
      mergedTheme: a,
      triggerRef: m,
      triggerInnerRef: g,
      tooltipRef: u,
      handleClick: h,
      renderTrigger: y,
      getTooltipDisabled: C
    };
  },
  render() {
    var i;
    const {
      tooltip: s,
      renderTrigger: o,
      $slots: n
    } = this;
    if (s) {
      const {
        mergedTheme: a
      } = this;
      return p(P, Object.assign({
        ref: "tooltipRef",
        placement: "top"
      }, s, {
        getDisabled: this.getTooltipDisabled,
        theme: a.peers.Tooltip,
        themeOverrides: a.peerOverrides.Tooltip
      }), {
        trigger: o,
        default: (i = n.tooltip) !== null && i !== void 0 ? i : n.default
      });
    } else
      return o();
  }
});
export {
  R as createCursorClass,
  b as createLineClampClass,
  q as default,
  B as ellipsisProps
};
